// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {alertService} from "../../../services/AlertService";

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {distentionSelector, getDistention, insertDistention, updateDistention,} from "./distentionSlice";

import {Colors} from "../../../assets/Colors";
import {maxPageGlobal} from "../../../assets/config";

const DistentionPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(maxPageGlobal);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const distention = useSelector(distentionSelector);

    useEffect(() => {
        dispatch(
            getDistention({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {
        if (search !== "" && distention.isGetSuccess && !distention.isGetFetching) {
            let calc = distention?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = distention.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if (search === "" && distention.isGetSuccess && !distention.isGetFetching) {
            let calc = distention?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = distention.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (
            !distention?.isGetFetching &&
            distention.isGetSuccess &&
            maxPage === 0 &&
            firstLoading === false
        ) {
            let calc = distention?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = distention.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(
                getDistention({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            if (distention.isGetSuccess) {
                alertService.success(distention.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    getDistention({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }

        if (updateFetch) {
            setUpdateFetch(false);
            if (distention.isUpdateSuccess) {
                alertService.success(distention.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    updateDistention({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }
    });

    // function handleGetDistention(params) {
    //   return dispatch(getDistention(params));
    // }

    function handleInsertDistention(param) {
        setInsertFetch(true);
        const params = {
            DestinationName: param.inputOneValue,
            Keterangan: param.inputTwoValue,
        };

        dispatch(insertDistention(params));
    }

    function handleUpdateDistention(param) {
        setUpdateFetch(true);

        const params = {
            DestinationName: param.inputOneValue,
            DestinationID: currentData.DestinationID,
            Keterangan: param.inputTwoValue,
            status: param.status,
        };
        dispatch(updateDistention(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getDistention(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getDistention(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = distention.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? distention.count : newCount,
            search: search,
        };
        dispatch(getDistention(params));

        setPage(1);
        setCount(newCount === "-1" ? distention.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>;
    } else {
        return (
            <div className="md:ml-64">
                <div
                    style={{background: Colors.primary}}
                    className="pt-14 pb-16 px-3 md:px-8 h-auto"
                >
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>
                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="Distention"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Destination"
                                tableData={distention.data}
                                colOneTitle="ID"
                                colOneData="DestinationID"
                                colTwoTitle="Nama Destination"
                                colTwoData="DestinationName"
                                colThreeTitle="Keterangan"
                                colThreeData="Keterangan"
                                status="Status"
                                fetching={distention.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}
                            />
                        </div>
                    </div>
                </div>
                {showModalAdd && (
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Destination"
                        inputOneTitle="Nama Destination"
                        inputOneValue=""
                        inputTwoTitle="Keterangan"
                        inputTwoValue=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertDistention}
                    />
                )}
                {showModalEdit && (
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.DestinationID}
                        modal={handleModal}
                        modalTitle="Ubah Destination"
                        inputOneTitle="Nama Destination"
                        inputOneValue={currentData.DestinationName}
                        inputTwoTitle="Keterangan"
                        inputTwoValue={currentData.Keterangan}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateDistention}
                    />
                )}
            </div>
        );
    }
};

export default DistentionPage;
